import visitor from "../visitor/index";
import lang from "../../lang";
import Cache from "c-cache";
import global from "../../base/global";
import sendBlackbox from "../TD/sendBlackbox"; // 上报同盾数据
import { profileGet } from '@js/service';

let cache = new Cache({
  prefix: "uplive",
});

class Profile {
  constructor(vuid) {
    this.promise = this.getData({
      vuid,
    });
    this.vuid = vuid;
  }

  getData(data) {
    let self = this;
    let defer = $.Deferred();
    let userToken = global.getUser().userToken;
    let uid = global.getUser().uid;
    profileGet({
        params: data,
        header: {
            lang: lang.type,
        }
    }).then(res => {
      console.log({res})
        if (res.code == 1) {
            data = res.data;

            if (self.vuid == uid) {
                data.userToken = userToken;
            }
            let userInfo = Object.assign(
                {},
                data.profile,
                self.parseData(data.profile),
                {
                userLabels: data.userLabels,
                }
            );
            defer.resolve(userInfo);
        } else {
            if (res.code == 8192 || res.code == 4096) {
                if (cache.getCache("isRegisterRealUser")) {
                    $.channel.emit("login");
                } else {
                    self.checkVisitorMode();
                }
            } else {
                defer.reject();
            }
        }
    }).catch(() => {
        defer.reject();
    });

    return defer.promise();
  }

  /*
   * 解析数据
   */
  parseData(data) {
    let balance = data.balance || {};
    return {
      uid: this.longToString(data.uid), // 用户UID
      balance: {
        diamond: this.longToInt(balance.diamond),
        bill: this.longToInt(balance.bill),
        inBill: this.longToInt(balance.inBill),
        outDiamond: this.longToInt(balance.outDiamond),
      },
      exp: this.longToInt(data.exp), // 用户经验值
      currentExp: this.longToInt(data.currentExp), //当前级的经验值
      nextExp: this.longToInt(data.nextExp), // 距离下一级还需要多少经验值
      chatroomid: this.longToString(data.chatroomid),
      officialAuth: data.officialAuth || 0, // 大V认证标识 1是 0否
    };
  }

  longToString(value) {
    return window.longToString(value);
  }

  longToInt(value) {
    value = this.longToString(value);

    return parseInt(value, 10) || 0;
  }

  checkVisitorMode() {
    this.visitor();
  }

  visitor() {
    cache.setCache("isRegisterRealUser", false);

    if (typeof SMSdk !== "undefined" && typeof tdBlackBox !== "undefined") {
      // visitor.F5Init();
      visitor.register();
    } else {
      $.channel.on("smsdkLoaded", () => {
        if (typeof tdBlackBox !== "undefined") {
          // visitor.F5Init();
          visitor.register();
        }
      });

      $.channel.on("tdsdkLoaded", (blackbox) => {
        let cacheBlackBox = cache.getCache("tdBlackBox");
        window.tdBlackBox = blackbox;
        let uid = global.getUser().uid;

        // 如果缓存blackbox != 新blackbox
        if (cacheBlackBox != blackbox) {
          //console.log('缓存串: ', cacheBlackBox, '\n新串: ', blackbox);
          // 设置新blackbox缓存
          cache.setCache("tdBlackBox", window.tdBlackBox);
          // 上报blackbox（key: uid, value: blackbox）
          uid && sendBlackbox({ key: uid, value: blackbox });
        }
        if (typeof SMSdk !== "undefined") {
          // visitor.F5Init();
          visitor.register();
        }
      });
    }
  }
}

export default Profile;



// WEBPACK FOOTER //
// ./js/component/profile/index.js